import "./style.css";
import React, { useState, useEffect, useContext } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import Logo from "../../../../resources/logo.png";
import buzzCutImg from "../../../../resources/fund_unutra.jpg";
import { CartContext } from "../../../../context/CartContext";
import { host } from "../../../../config/Config";
import EducationBreadcrumb from "../../../../common/EducationBreadcrumb";

export const Fundamental = () => {
    const phoneNumber = "+381 60-3859-426";
    const { addToCart } = useContext(CartContext);
    const [price, setPrice] = useState(0);
    const [loading, setLoading] = useState(true);
    const [hasAvailableSlots, setHasAvailableSlots] = useState(false);
    const [slotMessage, setSlotMessage] = useState("");
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Trigger fade in after a brief delay
        setTimeout(() => {
            setFadeIn(true);
        }, 100);

        fetch(`${host}/api/v1/education-prices/type/fundamental`)
            .then((response) => response.json())
            .then((data) => {
                setPrice(data.price);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching price:", error);
                setPrice(50);
                setLoading(false);
            });

        fetch(`${host}/api/v1/education-slots/type/fundamental`)
            .then((response) => response.json())
            .then((slots) => {
                const activeSlots = slots.filter(
                    (slot) =>
                        slot.status === "ACTIVE" && slot.availableSlots > 0
                );
                if (activeSlots.length > 0) {
                    setHasAvailableSlots(true);
                } else {
                    setHasAvailableSlots(false);
                    const hasSlots = slots.some(
                        (slot) => slot.status === "ACTIVE"
                    );
                    setSlotMessage(
                        hasSlots
                            ? "Svi termini su trenutno popunjeni. Molimo kontaktirajte nas za više informacija."
                            : "Trenutno nema dostupnih termina za ovu edukaciju. Molimo kontaktirajte nas."
                    );
                }
            })
            .catch((error) => {
                console.error("Error fetching slots:", error);
                setHasAvailableSlots(false);
                setSlotMessage(
                    "Trenutno nema dostupnih termina za ovu edukaciju."
                );
            });
    }, []);

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div className='page-workshop'>
            <EducationBreadcrumb />

            <div className={`items-workshop ${fadeIn ? "fade-in" : ""}`}>
                <h1 className='title-main'>Fundamental</h1>
                <h1 style={{ marginTop: "-19px" }}>Osnovni Nivo</h1>
                <h1 style={{ marginTop: "-19px" }}>Nivo 1</h1>
                <p>
                    Ova četvorodnevna fundamentalna edukacija namenjena je
                    profesionalcima koji žele da izrade čvrste temelje tehničkog
                    znanja i razumevanja forme. Ovaj program predstavlja prvi i
                    najvažniji korak u razvoju svakog frizera i barbera, jer
                    postavlja bazu za savremene i napredne tehnike šišanja.
                </p>

                <img
                    src={buzzCutImg}
                    alt='Fundamental Education'
                    style={{
                        width: "85%",
                        maxWidth: "600px",
                        height: "auto",
                        borderRadius: "15px",
                        border: "3px solid #be9455",
                        marginTop: "20px",
                        marginBottom: "20px",
                    }}
                />

                <p>
                    Tokom edukacije polaznici detaljno prolaze kroz sve klasične
                    oblike šišanja analizirajući strukturu, proporcije i
                    kontrolu tehnike. Fokus je na arhitekturi frizure, poziciji
                    kosti, balansu i svesnoj primeni tehnike radi postizanja
                    preciznih, čistih i nosivih linija.
                </p>
                <p style={{ textAlign: "center" }}>
                    Svaki dan obuke struktuiran je kroz tri ključne faze
                </p>
                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Teorija
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    Razumevanje oblika, strukture i principa raspodela tehnike
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Demonstracija
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    Prikaz svake forme korak po korak uz tehničko obrazloženje
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Praktičan rad
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    Samostalno izvođenje na profesionalnim lutkama uz mentorsku
                    podršku
                </p>

                <img
                    src={Logo}
                    style={{ width: "140px", borderRadius: "8px" }}
                />

                <p style={{ fontSize: "22px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Cilj edukacije je razviti modernu tehniku, kontrolu,
                    vizuelnu svest i sigurnost u oblikovanju savremene frizure.
                </p>
                <p style={{ fontSize: "22px", marginBottom: "30px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Svi materijali i profesionalne usluge uključeni su u cenu
                    edukacije.
                </p>
                {!loading && (
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: "32px",
                            fontWeight: "bold",
                            color: "#be9455",
                            marginTop: "30px",
                            marginBottom: "10px",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        Cena: {price.toLocaleString()} EUR
                    </div>
                )}
                <div
                    className={`buy-button-workshop ${
                        !hasAvailableSlots ? "disabled" : ""
                    }`}
                    onClick={() => {
                        if (hasAvailableSlots) {
                            addToCart({
                                id: "fundamental",
                                name: "Fundamental Workshop",
                                price: price,
                                category: "workshop",
                            });
                        }
                    }}
                    style={{
                        opacity: hasAvailableSlots ? 1 : 0.5,
                        cursor: hasAvailableSlots ? "pointer" : "not-allowed",
                    }}
                >
                    <p>{hasAvailableSlots ? "Dodaj u korpu" : "Nedostupno"}</p>
                </div>
                {slotMessage && (
                    <p
                        style={{
                            color: "#e74c3c",
                            textAlign: "center",
                            marginTop: "10px",
                            fontSize: "19px",
                            fontStyle: "italic",
                        }}
                    >
                        {slotMessage}
                    </p>
                )}
            </div>

            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
